import { formatCurrency } from "@helpers/funciones";
import { LoanApplicationOfferResponse } from "@interfaces/MarketPlace";

import { Grid, Box, useTheme, Typography, Button, Divider } from "@mui/material";
import iconDefualt from "@assets/img/defaul_icion_finace.png";

interface CreditOfferCardProps {
  offer: LoanApplicationOfferResponse;
  offers_length: number;
  showButton: boolean;
  onSelectOffer?: () => void;
  index?: number;
}

const fontSize = "18px";

const CreditOfferCard: React.FC<CreditOfferCardProps> = ({
  offer,
  offers_length,
  showButton,
  onSelectOffer,
  index = 0,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%" }}>
      {offers_length !== 0 && (
        <Box sx={{ paddingTop: "10px" }}>
          <Typography fontWeight={500} variant={"body1"} color={"#FF9E1B"} align="center">
            Oferta {index + 1} de {offers_length}
          </Typography>
        </Box>
      )}

      <Box display="flex" justifyContent="center" alignItems="center">
        <div
          style={{
            width: "150px",
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
          }}
        >
          <img
            src={
              offer.financial_company?.logo
                ? `${import.meta.env.VITE_URL_STATIC_RESOURCES}/${offer.financial_company.logo}`
                : iconDefualt
            }
            alt={offer.financial_company?.name || "Financiera"}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = iconDefualt;
            }}
          />
        </div>
      </Box>

      <Grid container flexDirection={"row"} mt={4}>
        <Grid item xs={6}>
          <Typography
            sx={{ mb: 1 }}
            variant={"body1"}
            fontWeight={600}
            color={theme?.palette?.primary?.main}
            textAlign={"center"}
          >
            Monto
          </Typography>
          <Typography fontSize={fontSize} fontWeight={600} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            {formatCurrency(offer.loan_amount || 0)} MXN
          </Typography>
        </Grid>

        <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #F2704F" }} />

        <Grid item xs={6}>
          <Typography
            sx={{ mb: 1 }}
            variant={"body1"}
            fontWeight={600}
            color={theme?.palette?.primary?.main}
            textAlign={"center"}
          >
            Plazo
          </Typography>
          <Typography fontSize={fontSize} fontWeight={600} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            {offer.term} meses
          </Typography>
        </Grid>
      </Grid>

      <Grid container flexDirection={"row"} mt={4}>
        <Grid item xs={6}>
          <Typography
            sx={{ mb: 1 }}
            variant={"body1"}
            fontWeight={600}
            color={theme?.palette?.primary?.main}
            textAlign={"center"}
          >
            Tasa
          </Typography>
          <Typography fontSize={fontSize} fontWeight={600} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            {offer.interest_rate}%
          </Typography>
        </Grid>

        <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #F2704F" }} />

        <Grid item xs={6}>
          <Typography
            sx={{ mb: 1 }}
            variant={"body1"}
            fontWeight={600}
            color={theme?.palette?.primary?.main}
            textAlign={"center"}
          >
            Comisión Aper.
          </Typography>
          <Typography fontSize={fontSize} fontWeight={600} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            {offer.opening_fee}%
          </Typography>
        </Grid>
      </Grid>

      <Box mb={2} mt={2}>
        <Typography
          sx={{ mb: 1 }}
          variant={"body1"}
          fontWeight={600}
          color={theme?.palette?.primary?.main}
          textAlign={"center"}
        >
          Pago Mensual Estimado
        </Typography>

        <Typography fontSize={fontSize} fontWeight={600} color={theme?.palette?.primary?.dark} textAlign={"center"}>
          {formatCurrency(offer.monthly_amount || 0)} MXN
        </Typography>
      </Box>
      {showButton && (
        <>
          <Box display="flex" justifyContent="center" mt={2} mb={2}>
            <Button variant="yellow" onClick={onSelectOffer}>
              Elegir Oferta
            </Button>
          </Box>
        </>
      )}
      <Box mb={2}>
        <Typography variant={"body2"} fontWeight={400} textAlign={"center"} color={theme?.palette?.primary?.dark}>
          Vigencia: {offer.days_validity} {offer.days_validity === 1 ? "día" : "días"}
        </Typography>
      </Box>
    </Box>
  );
};

export default CreditOfferCard;
